// React
import React from 'react';
import classNames from 'classnames';
// Material UI
import TextField from '@material-ui/core/TextField';
// Styles
import useStyles from './CustomTextField.styles';
import Conditional from '../conditional';
import StringUtils from '../../../utils/StringUtils';

const CustomTextField = ({
  classes = {},
  endAdornment = <></>,
  error = false,
  helperText = '',
  highlight = false,
  label = '',
  maxLength = 0,
  minLength = 0,
  placeholder = '',
  readOnly = false,
  required = false,
  startAdornment = <></>,
  useExternalLabel = false,
  value,
  disabled = false,
  ...props
}) => {
  const componentClasses = useStyles();

  const inputLabelProps = {
    classes: {
      root: classNames(componentClasses.rootLabel, classes.rootLabel),
      focused: componentClasses.focusedLabel,
      outlined: classNames(
        componentClasses.labelOutlined,
        classes.labelOutlined,
      ),
    },
  };

  const emailInputProps = {
    classes: {
      adornedEnd: classNames(componentClasses.adornedEnd, classes.adornedEnd),
      adornedStart: classNames(
        componentClasses.adornedStart,
        classes.adornedStart,
      ),
      root: classNames(
        componentClasses.rootInput,
        classes.rootInput,
        highlight && componentClasses.rootInputHiglighted,
      ),
      ...(props?.variant !== 'standard' && {
        notchedOutline: classNames(
          componentClasses.notchedOutlineInput,
          classes.notchedOutlineInput,
        ),
      }),
      error: componentClasses.error,
      focused: componentClasses.focusedInput,
      disabled: componentClasses.disabledInput,

      input: classNames(componentClasses.input, classes.input),
    },
    inputProps: {
      maxLength: maxLength === 0 ? undefined : maxLength,
      minLength,
    },
    endAdornment: endAdornment,
    readOnly: readOnly,
    startAdornment: startAdornment,
  };

  if (required && placeholder) placeholder += ' *';

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <Conditional if={useExternalLabel && !StringUtils.isNullOrEmpty(label)}>
        <div className={componentClasses.labelContainer}>{label}</div>
      </Conditional>
      <TextField
        classes={{
          root: classNames(
            componentClasses.textFieldRoot,
            classes.textFieldRoot,
          ),
        }}
        error={error}
        helperText={helperText}
        InputLabelProps={inputLabelProps}
        InputProps={emailInputProps}
        label={useExternalLabel ? null : label}
        placeholder={placeholder}
        required={required}
        value={value === null ? '' : value}
        disabled={disabled}
        {...props}
      />
    </div>
  );
};

CustomTextField.defaultProps = {
  autoFocus: false,
  classes: {},
  fullWidth: true,
  highlight: false,
  label: null,
  margin: 'none',
  readOnly: false,
  required: false,
  useExternalLabel: false,
  variant: 'outlined',
};

export default CustomTextField;
